import '../vendor';

import '../general/ofi';

import './one-exponat/modal-exponat';
import './game-puzzle/game-puzzle';
import './game-puzzle/game-puzzle-full';


// WEBPACK FOOTER //
// ./src/js/pages/game-puzzle.js